import { AlertIcon as ChakraAlertIcon } from '@chakra-ui/react'

import { AlertIconProps } from './AlertIcon.types'

export default function AlertIcon(props: AlertIconProps) {
  return <ChakraAlertIcon {...props} translate="no" />
}
